module.exports = __webpack_public_path__ + "media/customizations/rendezvous/logo-d8c82e288f32cec943e7f2f1defa1f98.png";